export const CHECKBOX_TOGGLE_CONTAINER = '.js-checkbox-toggle-container';
